import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ConfigurationFacade } from '../facades/configuration.facade';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppUtils } from '../utils/app.utils';
import { FEATURE_CONFIG } from '../configurations/common';

@Injectable({
  providedIn: 'root'
})
export class StoreAccessibilityGuard implements CanActivate {
  private readonly router: Router = inject(Router);
  private readonly configFacade: ConfigurationFacade = inject(ConfigurationFacade);

  isStoreEnabled: boolean = true;

  canActivate(): Observable<boolean> {
    if (this.isStoreEnabled) {
      return this.configFacade.getTranslationByKey(
        `${FEATURE_CONFIG}stores.${AppUtils.getCurrentMarket().toUpperCase()}.enabled`
      ).pipe(map((isStoreAccessible: string) => {
        this.isStoreEnabled = isStoreAccessible === 'true';
        if (!this.isStoreEnabled) {
          this.router.navigate(['']).then();
        }
        return this.isStoreEnabled;
      }));
    }
    return of(this.isStoreEnabled);
  }
}
